import { controls, currencyToNumber, grouped } from "../../controls";

const rpttgccol1 = {
  label: "School Wise Work Status",
  starting: true,
  url: "rptgc2",
  pageLabel: "School Wise Work Status",
  pageType: "history",
  // filteraction: true,
  filter: [
    ...controls.displayText({ tab: "general", label: "Taluka", star: true }),
    ...controls.oc({ tab: "general", c: "Taluka", placeHolder: "Taluka Code", name: "taluka_code", isRequired: true, fastpath: "talukas" }),
    ...controls.showData({ tab: "general", displaytype: "capital", data: "taluka_display" }),
  ],
  form: [],
  history: {
    perPage: 50,
    reportHeader: "Work Status Report",
    filterable: true,
    sortable: true,
    defaultsTo: 0,
    pdfProps: { pageSize: "A3", pageOrientation: "landscape" },
    pivotable: true,
    extraRows: {
      location: "top",
      fields: ["total_probable", "probable_work_comp", "pending_probable", "total_system_match", "system_match_comp", "pending_system_match", "total_not_match", "not_match_comp", "pending_not_match"],
      subtotals: {
        by: "village",
        displayIn: "village",
      }



    },

    displayColumns: [
      {
        Header: "Sr", type: "autoinc", accessor: "srno", align: "center", width: 30,
        width132: { size: 3 }
      },
      {
        Header: "Taluka Name",
        accessor: "taluka",
        rwidth: "*"
      },
      {
        Header: "Village Name",
        accessor: "village",
      },
      {
        Header: "School Code",
        accessor: "school_code",
      },
      {
        Header: "School Name ",
        accessor: "school_display",
      },
      {
        Header: "Mobile No ",
        accessor: "username",
      },
      {
        Header: "User Display",
        accessor: "user_display",
      },
      {
        Header: "Last Login Time",
        accessor: "last_login_time",
      },


      {
        Header: "Probable Match",
        columns: [
          {
            Header: "Total",
            accessor: "total_probable",
          },
          {
            Header: "Completed",
            accessor: "probable_work_comp",

          },
          {
            Header: "Pending",
            accessor: "pending_probable",

          },
        ]
      },
      {
        Header: "System Match",
        columns: [
          {
            Header: "Total",
            accessor: "total_system_match",
          },
          {
            Header: "Completed",
            accessor: "system_match_comp",

          },
          {
            Header: "Pending",
            accessor: "pending_system_match",

          },
        ]
      },
      {
        Header: "No Match",
        columns: [
          {
            Header: "Total",
            accessor: "total_not_match",
          },
          {
            Header: "Completed",
            accessor: "not_match_comp",
            align: "right"
          },
          {
            Header: "Pending",
            accessor: "pending_not_match",
            align: "right"
          },
        ]
      },
      {
        Header: "Total Work Done",
        accessor: "total_work",
      },
      {
        Header: "Completed Work",
        accessor: "completed_work",
      },
      {
        Header: "Pending Work",
        accessor: "pending",
      },
      {
        Header: "Percentage Work",
        accessor: "percentage_work",
      },
    ]
  }
};

export default rpttgccol1;